import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-play-circle-fill text-background-50 text-xl"></i>
          </div>
          <span className={`font-heading text-xl font-bold transition-colors duration-300 ${
            isScrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
          }`}>
            麻豆在线
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
              location.pathname === '/'
                ? 'bg-primary-100 text-primary-700'
                : isScrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
            }`}
          >
            首页
          </Link>
          {categories.slice(0, 4).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname.includes(cat.slug)
                  ? 'bg-primary-100 text-primary-700'
                  : isScrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
              location.pathname === '/about'
                ? 'bg-primary-100 text-primary-700'
                : isScrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
            }`}
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/category/huiyuan-zhuanxiang"
            className="px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            加入会员
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="切换菜单"
        >
          <i className={`text-xl ${isScrolled || !isHome ? 'text-foreground-900' : 'text-background-50'} ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors">首页</Link>
            {categories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors">
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors">关于我们</Link>
            <Link
              to="/category/huiyuan-zhuanxiang"
              className="mt-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold text-center hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
            >
              加入会员
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}